<template>
    <div id="main-layout-left">
        <div id="navigation-container">
            <AccountMenu />
        </div>

        <Tabs />

        <div id="blocks-container--outer">
            <RawDevelopment v-show="showRawDevelopment" />
            <ul id="blocks-container" class="adjustment-blocks-container ui-sortable"></ul>
        </div>

        <div id="candidates-container" class="hide">
            <CandidateTemplate v-for="candidate in filteredCandidates" :key="candidate.id" :candidate="candidate" />
            <v-btn v-if="filteredCandidates.length > 0" @click="clearCandidates" class="color-gray d-block rounded-xl mx-auto mt-5" outlined>
                Clear Selections
            </v-btn>
        </div>

        <AddBlockButton />
        <div id="blocks-selector" class="hide">
            <ProductsList />
        </div>
    </div>
</template>

<script>
import AccountMenu from '@/components/account-menu/Menu';
import Tabs from '@/components/app/ui/LeftSidebarTabs';
import CandidateTemplate from '@/components/app/assets/CandidateTemplate';
import AddBlockButton from '@/components/app/buttons/AddBlock';
import ProductsList from '@/components/app/blocks/ProductsList';
import RawDevelopment from '@/components/app/blocks/RawDevelopment/RawDevelopment';
import { candidatesStore } from '@/services/indexedDB.service';

import { mapGetters, mapState } from 'vuex';

export default {
    name: 'MainLayoutLeft',

    components: {
        AccountMenu,
        Tabs,
        AddBlockButton,
        RawDevelopment,
        CandidateTemplate,
        ProductsList
    },

    computed: {
        ...mapState('UI', ['showRawDevelopment', 'candidates']),
        ...mapGetters('UI', ['filteredCandidates']),

        candidateTemplate() {
            return CandidateTemplate;
        },
    },

    methods: {
        async clearCandidates() {
            await candidatesStore.clear();
            await window.lutify.switchCandidates();
        },
    }
};
</script>